<template>
	<div class="top-menu">
		<el-menu :default-active="activeIndex" mode="horizontal" text-color="#333">
			<template v-for="(item, index) in items">
				<el-menu-item :key="index" :index="item.parentId + ''" @click.native="openMenu(item)">
					<template slot="title">
						<i :class="item.icon" />
						<span>{{ item.label }}</span>
					</template>
				</el-menu-item>
			</template>
		</el-menu>
	</div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
	name: 'TopMenu',
	inject: ['Index'],
	data() {
		return {
			activeIndex: '0',
			items: [],
		}
	},
	created() {
		// 显示顶部菜单
		this.getTopMenu()
		// 用户权限加载
		this.getUserInfo()
		// this.getSettleInfo()
		this.getInsureTypes()
	},
	computed: {
		...mapGetters(['menu']),
	},
	methods: {
		getTopMenu() {
			this.$store
				.dispatch('GetTopMenu')
				.then((res) => {
					this.items = res
				})
				.catch(() => {})
		},
		openMenu(item) {
			this.Index.openMenu(item)
		},
		getUserInfo() {
			// 更新sessionStore 权限信息
			this.$store
				.dispatch('GetUserInfo')
				.then(({sysUser: {userType = ''} = {}}) => {
					if (userType === 'dist') {
						//获取主渠道数据 只有投保权限才请求
						this.$store.dispatch('GetUserInfoMain')
					}
				})
				.catch(() => {})
		},
		//获取产品类型
		getInsureTypes() {
			this.$store.dispatch('getInsureTypes').catch(() => {})
		},

		// getSettleInfo() {
		//   let {distAccount} = this.$store.state.user.userInfo || {}
		//   //主渠道
		//   if (!this.validatenull(distAccount) && distAccount.role === 4) {
		//     //获取用户结算信息
		//     this.$store.dispatch('GetSettleInfo')
		//   }
		// }
	},
}
</script>
